<template>
  <!-- <f7-fab-speed-dial ref="speedDial" :class="{ 'tabbar-fixed-speed-dial-material' : $theme.md  && MainMenuLayout===1, 'tabbar-fixed-speed-dial-ios' : !$theme.md  && MainMenuLayout===1 }">
    <f7-fab-actions>
      <f7-fab-action @click="LikeClick()" v-if="ShowLike">
        <span class="custom-icon" :class="{'icon-like' : !IsLike , 'icon-dislike' : IsLike}"></span>
      </f7-fab-action>
      <f7-fab-action @click="FavoriteClick()" v-if="false">
        <span class="custom-icon" :class="{'icon-favorites-add' : !IsFavorite , 'icon-favorites-remove' : IsFavorite}"></span>
      </f7-fab-action>
      <f7-fab-action @click="ShareCLick()" v-if="ShowShare">
        <span class="custom-icon icon-share"></span>
      </f7-fab-action>
    </f7-fab-actions>
    <f7-fab v-if="ShowLike || false || ShowShare">
      <f7-icon icon="icon-plus"></f7-icon>
      <f7-icon icon="icon-close"></f7-icon>
    </f7-fab>
  </f7-fab-speed-dial> -->
  <!-- <div class="fab fab-right-bottom">
  <a href="#">
    <i class="icon icon-plus"></i>
    <i class="icon icon-close"></i>
  </a>
  <div class="fab-buttons fab-buttons-top">
    <a href="#">1</a>
    <a href="#">2</a>
    <a href="#">3</a>
  </div>
</div> -->
<div class="fab fab-right-bottom" ref="speedDial" :class="{ 'tabbar-fixed-speed-dial-material' : $theme.md  && MainMenuLayout===1, 'tabbar-fixed-speed-dial-ios' : !$theme.md  && MainMenuLayout===1 }">
  <a href="#" v-if="ShowLike || false || ShowShare" class="floating_btn_class">
    <f7-icon f7="add" class="floating_btn_class"></f7-icon>
    <f7-icon f7="close" class="floating_btn_class"></f7-icon>
  </a>
  <f7-fab-buttons>
    <f7-fab-button @click="LikeClick()" v-if="ShowLike">
      <span class="custom-icon" :class="{'icon-like' : !IsLike , 'icon-dislike' : IsLike}"></span>
    </f7-fab-button>
    <f7-fab-button @click="FavoriteClick()" v-if="false">
      <span class="custom-icon" :class="{'icon-favorites-add' : !IsFavorite , 'icon-favorites-remove' : IsFavorite}"></span>
    </f7-fab-button>
    <f7-fab-button @click="ShareCLick()" v-if="ShowShare">
      <span class="custom-icon icon-share"></span>
    </f7-fab-button>
  </f7-fab-buttons>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { IsUserActionAllow } from '@/modules/helper/index';
import DeviceInfo from '@/modules/util/deviceInfo';
export default {
  props: {
    ShowLike: {
      type: Boolean,
      default: false
    },
    ShowFavorite: {
      type: Boolean,
      default: false
    },
    ShowShare: {
      type: Boolean,
      default: false
    },
    IsLike: {
      type: Boolean,
      default: false
    },
    IsFavorite: {
      type: Boolean,
      default: false
    },
    onLikeClick: {
      type: Function,
      default: () => {
        return () => {};
      }
    },
    onFavoriteClick: {
      type: Function,
      default: () => {}
    },
    onShareCLick: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["MainMenuLayout", "resource"])
  },
  created() {
    window.addEventListener('click', this.handleFabBtnClose)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleFabBtnClose)
  },
  methods: {
    handleFabBtnClose (event) {
      if (event.srcElement.className.indexOf('floating_btn_class') < 0 && this.$refs.speedDial) {
        this.$f7.fab.close(this.$refs.speedDial);
      }
    },
    LikeClick() {
      if (this.$refs.speedDial) {
        this.$f7.fab.close(this.$refs.speedDial);
        if (IsUserActionAllow()) {
          this.onLikeClick();
        } else {
          // this.$f7.addNotification({
          //   title: this.resource.warningTitle, // apply only ios theme
          //   message: this.resource.warningMessage,
          //   hold: 3000,
          //   closeIcon: false,
          //   button: {
          //     text: this.resource.closeBtn
          //   },
          //   additionalClass: 'error-notification' // apply only ios theme
          // })

          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          };
          this.$showModal(modalOptions);
        }
      }
    },
    FavoriteClick() {
      if (this.$refs.speedDial) {
        this.$f7.fab.close(this.$refs.speedDial);
        if (IsUserActionAllow()) {
          this.onFavoriteClick();
        } else {
          // this.$f7.addNotification({
          //   title: this.resource.warningTitle, // apply only ios theme
          //   message: this.resource.warningMessage,
          //   hold: 3000,
          //   closeIcon: false,
          //   button: {
          //     text: this.resource.closeBtn
          //   },
          //   additionalClass: 'error-notification' // apply only ios theme
          // })

          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid
              ? this.resource.AndroidDownload
              : this.resource.AppleDownload,
            $f7: this.$f7
          };
          this.$showModal(modalOptions);
        }
      }
    },
    ShareCLick() {
      if (this.$refs.speedDial) {
        this.$f7.fab.close(this.$refs.speedDial);
        // this.$refs.speedDial.classList.remove('fab-opened')
        if (IsUserActionAllow()) {
          this.onShareCLick();
        } else {
          // this.$f7.addNotification({
          //   title: this.resource.warningTitle, // apply only ios theme
          //   message: this.resource.warningMessage,
          //   hold: 3000,
          //   closeIcon: false,
          //   button: {
          //     text: this.resource.closeBtn
          //   },
          //   additionalClass: 'error-notification' // apply only ios theme
          // })
          // let modalOptions = {
          //   title: this.resource.warningTitle,
          //   text: this.resource.warningMessage,
          //   buttonText: this.resource.closeBtn,
          //   downloadbuttonText: DeviceInfo.isAndroid
          //     ? this.resource.AndroidDownload
          //     : this.resource.AppleDownload,
          //   $f7: this.$f7
          // };
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid
              ? this.resource.AndroidDownload
              : this.resource.AppleDownload,
            $f7: this.$f7
          };
          this.$showModal(modalOptions);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/FloatingButton.vue